



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SignaturePad from '@core/tools/CustomSignaturePad'
import API from '@core/services/API'
import { inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component({})
export default class AppSignatureBox extends Vue {
  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private $api: API

  @Prop({ default: {} }) readonly footerBtn!: object
  @Prop({ default: false }) readonly showSignPad!: boolean
  @Prop({ default: true }) readonly clearOnShow!: boolean

  private signaturePad = null
  // userSignature is used to show existing signature (saved by user) and intercept save behavior
  private userSignature = null

  clearSignature () {
    if (this.signaturePad) {
      this.userSignature = null
      this.signaturePad.clear()
    }
  }

  async triggerSave () {
    const noSigned = this.signaturePad.isEmpty()
    if (noSigned) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'No signature is detected! Please try again!'
      })
      return
      // NOTE : do not allow overwrite signature with blank canvas as this causes complication in checking whether signature is done
      // if (confirm('No signature is detected!\nClick CANCEL to try again\nClick OK to save ( remove existing signature if any ).')) {
      //   this.saveSignature(noSigned)
      // }
    }
    // intercept save behavior, toDataURL will fail if fromDataURL is used
    if (this.userSignature) return this.$emit('save', this.userSignature)
    const signatureData = this.signaturePad.toDataURL('image/svg+xml')
    this.$emit('save', signatureData) // return the signature data for parent to handle
  }

  mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService

    const canvas = document.querySelector('.signaturePadLine canvas') as HTMLCanvasElement
    this.signaturePad = new SignaturePad(canvas, {
      maxWidth: 3
    })
  }

  @Watch('showSignPad')
  prepSignPad (show) {
    if (show) {
      this.clearSignature()
      this.retrieveUserSignature()
    }
  }

  retrieveUserSignature () {
    this.$api.signature.retrieve({})
      .then(res => {
        if (!res.error && res.signature) {
          console.log(res.signature)
          this.userSignature = res.signature
          this.signaturePad.fromDataURL(res.signature)
        }
      }).catch(err => {
        alert(err)
      })
  }
}
